import { connect } from 'react-redux';
import BudgetRecaps from '../../../../views/Finance/Budgeting/Budget/BudgetRecaps.finance.view';
import { getBudgetRecaps } from '../../../../states/thunks/finance.thunk';
import { getUnitOptions, getPerwakilanOptions } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    perwakilan: state.options.perwakilan,
    unit: state.options.unit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetBudgetRecaps: payload => dispatch(getBudgetRecaps(payload)),
    handleGetUnitOptions: payload => dispatch(getUnitOptions(payload)),
    handleGetPerwakilanOptions: payload => dispatch(getPerwakilanOptions(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BudgetRecaps);
